module.exports = __webpack_public_path__ + "5d2e524bef10352a0be58bb0201d1d17.png";